import { render } from "./DatosMenor.vue?vue&type=template&id=1c93236f&ts=true"
import script from "./DatosMenor.vue?vue&type=script&lang=ts"
export * from "./DatosMenor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__